/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, March 2020
 */
import { byteLength } from '../strings';
import { QueueStorage } from './QueueStorage';

/**
 * An IQueueStorage object for persisting Queues in LocalStorage.
 */
export class LocalQueueStorage<T> extends QueueStorage<T> {
    /**
     * Store a value in localStorage.
     * This will serialize the value as JSON an the store it.
     *
     * @param key Key of the value
     * @param value Value to store.
     */
    protected set(key: string, value: unknown): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    /**
     * Get a value from the store.
     * This will parse values from JSON an the return them.
     * If the value of the key exceeds the maxed size allowed
     *
     * @param key The key of the value to get.
     * @param defaultValue Value to return if the value isn't found.
     * @returns The stored value.
     */
    protected get<T>(key: string, defaultValue: T): T {
        const value = localStorage.getItem(key);

        // Nothing stored.
        if (value === null) {
            return defaultValue;
        }

        // Max byte length has been reached, clear the queue.
        if (byteLength(value) >= this.maxLength) {
            localStorage.removeItem(key);
        }

        // Parse the last stored data from the queue.
        // This will contain info even if the queue reached it's max length and was trimmed before.
        return JSON.parse(value);
    }
}



// WEBPACK FOOTER //
// ./src/packages/core/lib/queue/LocalQueueStorage.ts